// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"633":"d105b7138631d88e","722":"94e9af7ac23d1594"}[chunkId] + ".js";
};